import { cn } from "@/lib/utils";
import { UserButton } from "@clerk/clerk-react";
import { Outlet } from "react-router";
import { LoadingSpinner } from "../ui/loading-spinner";

interface LayoutProps {
  // Outlet context
  outletContext?: unknown;

  // Loading state
  isLoading?: boolean;
}

export const MinimalLayout = ({ outletContext, isLoading }: LayoutProps) => {
  return (
    <main
      className={cn("flex-1 flex flex-col h-dvh overflow-hidden")}
      style={{ overflowX: "hidden" }}
    >
      <header className="h-14 border-b flex shrink-0 items-center px-4 justify-between w-full">
        <div className="flex items-center gap-4 ml-auto">
          <UserButton
            appearance={{
              elements: {
                avatarBox: "w-8 h-8",
              },
            }}
            afterSignOutUrl="/sign-in"
          />
        </div>
      </header>

      <div className={cn("flex-1 overflow-auto")}>
        {isLoading ? <LoadingSpinner /> : <Outlet context={outletContext} />}
      </div>
    </main>
  );
};
